import React from 'react';
import StoryHeroRo from '../../components/ro/story/StoryHeroRo';
import WorldLostRo from '../../components/ro/story/WorldLostRo';
import SolarRebornRo from '../../components/ro/story/SolarRebornRo';
import HumanScaleRo from '../../components/ro/story/HumanScaleRo';
import SignalSectionRo from '../../components/ro/story/SignalSectionRo';
import WhyMattersRo from '../../components/ro/story/WhyMattersRo';

const StoryPageRo = () => (
  <main>
    <StoryHeroRo />
    <WorldLostRo />
    <SolarRebornRo />
    <HumanScaleRo />
    <SignalSectionRo />
    <WhyMattersRo />
  </main>
);

export default StoryPageRo;